"use client";

import React, { useEffect, useRef } from "react";

import { getPolarCheckoutUrl } from "@/lib/purchase";

export default function PolarCheckout() {
  const checkoutUrl = getPolarCheckoutUrl();
  const linkRef = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    // No checkout configured — don't load Polar's embed script at all.
    if (!checkoutUrl) return;

    const triggerCheckout = () => {
      // Fire the Polar checkout by programmatically clicking the trigger link
      linkRef.current?.click();
    };

    let timeoutId: number | undefined;

    const existing = document.querySelector<HTMLScriptElement>(
      'script[data-polar-embed="true"]',
    );

    if (existing) {
      // Script is already on the page (possibly loaded earlier) – just
      // schedule a trigger shortly after mount.
      timeoutId = window.setTimeout(triggerCheckout, 500);
      return () => {
        if (timeoutId) window.clearTimeout(timeoutId);
      };
    }

    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/@polar-sh/checkout@0.1/dist/embed.global.js";
    script.defer = true;
    script.setAttribute("data-auto-init", "true");
    script.setAttribute("data-polar-embed", "true");

    script.onload = () => {
      triggerCheckout();
    };

    document.body.appendChild(script);

    return () => {
      // We intentionally keep the script; this page is rarely revisited
      // in a single session and leaving it avoids double-loading.
    };
  }, [checkoutUrl]);

  // Nothing to link to — render nothing rather than a dead trigger.
  if (!checkoutUrl) return null;

  return (
    <section className="section">
      <div className="section-container">
        {/* Hidden trigger that Polar attaches to; we auto-click it on mount */}
        <a
          ref={linkRef}
          href={checkoutUrl}
          data-polar-checkout
          data-polar-checkout-theme="dark"
          style={{
            position: "absolute",
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: 0,
          }}
        >
          Purchase
        </a>
      </div>
    </section>
  );
}



